// extracted by mini-css-extract-plugin
module.exports = {"wt-checkbox":"wt-checkbox-18cf1cad974d5a5d9c77d00da18cced8"};